export function Divider() {
  return (
    <div
      className="h-[1px] w-full"
      style={{
        background: "linear-gradient(90deg, var(--grey-300) 0%, transparent 100%)",
      }}
    ></div>
  );
}
